<SocialTags
	pageTitle="Clases Online"
	pageDesc="Elige una disciplina y empieza a practicar hoy mismo, o simplemente explora nuestro contenido y aprende cosas nuevas cada día.
Cada día buscamos traer más diversidad a nuestra oferta."
	urlPath="/clases/"
></SocialTags>

<style src="./style.scss">

</style>

<main id="dnsPage" class="mbsc-grid d-ns-page classes-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
			selectedItem="classes"
		></MainMenu>
	</nav>

	<ClassContent
		categoryFilter={categoryFilter}
	></ClassContent>
	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import SocialTags from '@Components/SocialTags/index.svelte';
import MainMenu from '@Components/MainMenu/index.svelte';

import ClassContent from '@Pages/Clases/content.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { Navigation, Utils } from '@Services';

const DEBUG = document.location.protocol === 'http:' ? true : false;

export let router = null;

let categoryFilter = null;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {
	document.body.dispatchEvent(new Event('mbsc-enhance')); 
});

onMount(async () =>{
	if (DEBUG) console.log('App: ' + router.path);

	if (router.params.categorySlug) {
		categoryFilter = router.params.categorySlug;
	}else{
		categoryFilter = null;
	}

	mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

	mobiscroll.page('.classes-page', {});

	Utils.scrollToTop();
});
</script>
